import React, { useState } from "react";
import teethLogo from "../../assets/Images/teeth-logo.png";
import teethWhiteLogo from "../../assets/Images/teeth-white-logo.png";
import teethAquaLogo from "../../assets/Images/teeth-aqua-logo.png";
import lipsWhiteLogo from "../../assets/Images/lips-white-logo.png";
import lipsAquaLogo from "../../assets/Images/lips-aqua-logo.png";
import dentalWhiteLogo from "../../assets/Images/dental-white-logo.png";
import dentalAquaLogo from "../../assets/Images/dental-aqua-logo.png";
import service1 from "../../assets/Images/services-1.jpg";
import service2 from "../../assets/Images/services-2.jpg";
import service3 from "../../assets/Images/services-3.jpg";
import { FaPlus, FaMinus } from "react-icons/fa";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import allPaths from "../../Config/paths"

const Service = (props) => {
    const history = useHistory()
    const { selectedLanguage } = props

    const [cards, setCards] = useState([
        { card: false, whiteLogo: false },
        { card: false, whiteLogo: false },
        { card: false, whiteLogo: false }
    ]);
    const [card1, setCard1] = useState(false);
    const [card2, setCard2] = useState(false);
    const [card3, setCard3] = useState(false);
    const cardOne = () => {
        setCard1(!card1);
    };
    const cardTwo = () => {
        setCard2(!card2);
    };
    const cardThree = () => {
        setCard3(!card3);
    };
    const toggleWhiteLogo = (index, value) => {
        const newCards = [...cards];
        newCards[index].whiteLogo = value;
        setCards(newCards);
    };
    const handleScrollToTop = () => {
        window.scrollTo({
            top: 0,
        });
    };

    return (
        <div className="service-main">
            <div className="service-container">
                <div>
                    <div className="teeth-logo-div">
                        <img className="teeth-logo" src={teethLogo} alt="" />
                        <div className="service-heading-div">
                            <h2 className="service-heading">
                                {selectedLanguage?.our_services_heading}
                            </h2>
                        </div>
                    </div>
                    <div className="service-left-side-div" data-aos="fade-right"
                        data-aos-easing="ease-out-cubic"
                        data-aos-delay="100"
                        data-aos-offset="0"
                        data-aos-duration="1500">
                        {cards.map((item, index) => (
                            <div className="service-img-and-text-div" key={index} onMouseEnter={() => toggleWhiteLogo(index, true)} onMouseLeave={() => toggleWhiteLogo(index, false)}>
                                {!item.whiteLogo ? (
                                    <div onClick={handleScrollToTop} className="service-left-side-img-div">
                                        <img src={index === 0 ? teethAquaLogo : index === 1 ? dentalAquaLogo : lipsAquaLogo} alt="" />
                                    </div>
                                ) : (
                                    <div onClick={handleScrollToTop} className="service-left-side-img-div service-left-side-img-div-white-log">
                                        <img src={index === 0 ? teethWhiteLogo : index === 1 ? dentalWhiteLogo : lipsWhiteLogo} alt="" />
                                    </div>
                                )}
                                <div onClick={handleScrollToTop} className="service-left-side-text-div">
                                    <h2>
                                        {index === 0 ? selectedLanguage?.txt_diagnosis_and_gp : index === 1 ? selectedLanguage?.txt_aesthetics_dentistry : selectedLanguage?.txt_dental_implants}
                                    </h2>
                                    <p>{index === 0 ? selectedLanguage?.txt_our_dental_clinic_does_the_full_range_of_general_dentistry :
                                        index === 1 ? selectedLanguage?.txt_the_dental_science_are_undergoing_massive_change :
                                            selectedLanguage?.txt_the_field_of_Aesthetics_dentistry}</p>
                                </div>
                            </div>
                        ))}
                        <button data-aos="fade-up"
                            data-aos-easing="ease-out-cubic"
                            data-aos-delay="100"
                            data-aos-offset="0"
                            data-aos-duration="1000" className="card-section-2-btn service-btn" onClick={() => history?.push(allPaths?.SERVICE)}>{selectedLanguage?.read_more_button}</button>
                    </div>
                </div>
                <div className="service-right-side-container">
                    <div className="teeth-logo-div">
                        <img className="teeth-logo" src={teethLogo} alt="" />
                        <div className="service-heading-div service-heading-div-2">
                            <h2 className="service-heading">
                                {selectedLanguage?.special_offer_heading}
                            </h2>
                        </div>
                    </div>
                    <div className="service-right-side-div">
                        <div className="service-right-side-text-div">
                            <p>{selectedLanguage?.special_offer_paragraph}</p>
                        </div>
                        <div data-aos="fade-left"
                            data-aos-easing="ease-out-cubic"
                            data-aos-delay="100"
                            data-aos-offset="0"
                            data-aos-duration="1500">
                            {!card1 ? <div className="service-right-side-card">
                                <div className="service-1-img-div">
                                    <img src={service1} alt="" />
                                </div>
                                <div className="service-right-cards-text-div">
                                    <div className="service-right-cards-icon-div">
                                        <div className="add-icon" onClick={cardOne}>
                                            <FaPlus fontSize={13} />
                                        </div>
                                    </div>
                                    <div className="service-right-cards-text">
                                        <h2>{selectedLanguage?.teeth_whitening_heading}</h2>
                                        <p>{selectedLanguage?.teeth_whitening_paragraph}</p>
                                    </div>
                                </div>
                            </div>
                                :
                                <div className="service-right-side-close-card">
                                    <div className="minus-icon" onClick={cardOne}>
                                        <FaMinus fontSize={13} />
                                    </div>
                                    <div className="service-right-side-close-card-text-div">
                                        <h2>{selectedLanguage?.teeth_whitening_heading}</h2>

                                    </div>
                                </div>}
                            {card2 ? <div className="service-right-side-card">
                                <div className="service-1-img-div">
                                    <img src={service2} alt="" />
                                </div>
                                <div className="service-right-cards-text-div">
                                    <div className="service-right-cards-icon-div">
                                        <div className="add-icon" onClick={cardTwo}>
                                            <FaPlus fontSize={13} />
                                        </div>
                                    </div>
                                    <div className="service-right-cards-text">
                                        <h2>{selectedLanguage?.txt_dental_implants}</h2>
                                        <p>{selectedLanguage?.detal_implants_paragraph}</p>
                                    </div>
                                </div>
                            </div>
                                :
                                <div className="service-right-side-close-card">
                                    <div className="minus-icon" onClick={cardTwo}>
                                        <FaMinus fontSize={13} />
                                    </div>
                                    <div className="service-right-side-close-card-text-div">
                                        <h2>{selectedLanguage?.txt_dental_implants}</h2>
                                    </div>
                                </div>}
                            {card3 ? <div className="service-right-side-card">
                                <div className="service-1-img-div">
                                    <img src={service3} alt="" />
                                </div>
                                <div className="service-right-cards-text-div">
                                    <div className="service-right-cards-icon-div">
                                        <div className="add-icon" onClick={cardThree}>
                                            <FaPlus fontSize={13} />
                                        </div>
                                    </div>
                                    <div className="service-right-cards-text">
                                        <h2>{selectedLanguage?.smile_makeover_heading}</h2>
                                        <p>{selectedLanguage?.smile_makeover_paragraph}</p>
                                    </div>
                                </div>
                            </div>
                                :
                                <div className="service-right-side-close-card">
                                    <div className="minus-icon" onClick={cardThree}>
                                        <FaMinus fontSize={13} />
                                    </div>
                                    <div className="service-right-side-close-card-text-div">
                                        <h2>{selectedLanguage?.smile_makeover_heading}</h2>
                                    </div>
                                </div>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Service;
